import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '序号',
      prop: 'index'
    },
    {
      label: '俱乐部名称',
      prop: 'clubName'
    },
    {
      label: '队员姓名',
      prop: 'name'
    },
    {
      label: '队员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '级别',
      prop: 'level'
    }
  ]
}
